import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoMotivoPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoMotivo {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoMotivoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoMotivoService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_motivo`;

  constructor(private http: HttpClient) {}

  /**
   * Obtener todos los tipos de motivo
   */
  getAll(): Observable<TipoMotivo[]> {
    return this.http.get<TipoMotivo[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  /**
   * Obtener tipo de motivo por ID
   */
  getById(id: number): Observable<TipoMotivo> {
    return this.http.get<TipoMotivo>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Crear tipo de motivo
   */
  create(
    payload: TipoMotivoPayload
  ): Observable<TipoMotivoResponse> {
    return this.http.post<TipoMotivoResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Actualizar tipo de motivo
   */
  update(
    id: number,
    payload: Partial<TipoMotivoPayload>
  ): Observable<TipoMotivoResponse> {
    return this.http.put<TipoMotivoResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Eliminar tipo de motivo
   */
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Inactivar tipo de motivo
   */
  inactivar(id: number): Observable<TipoMotivoResponse> {
    return this.http.put<TipoMotivoResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  /**
   * Activar tipo de motivo
   */
  activar(id: number): Observable<TipoMotivoResponse> {
    return this.http.put<TipoMotivoResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}